export const TrackingCode = 'UA-90180579-14' // TODO: UAが廃止されたら削除
export const Ga4TrackingCodes = {
  production: 'G-QB83QCYM4P',
  development: 'G-TQDXZ14Q0R',
}
